import { updateWhatsNewState } from '@innovyze/stylovyze/lib/actions';
import { useSettings } from '@innovyze/stylovyze/lib/contexts/Settings';
import { useSiteConfig } from '@innovyze/stylovyze/lib/contexts/SiteConfiguration';
import { useGetCurrentApp, useIsForge } from '@innovyze/stylovyze/lib/hooks';
import { selectAuthenticationContext } from '@innovyze/stylovyze/lib/selectors/authenticationContext.selectors';
import { getCompaniesSettings } from '@innovyze/stylovyze/lib/utils/companySettings';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
export default function useGetSettingsForCompanies() {
    // state hooks
    const { companySettings, settingsLoaded } = useSettings();
    const dispatch = useDispatch();
    const { config, configLoaded } = useSiteConfig();
    const { isInitializing, user } = useSelector(selectAuthenticationContext);
    const isForge = useIsForge();
    // states
    const [settings, setSettings] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState();
    const shouldLoadSettings = !isInitializing && !loaded && settingsLoaded && configLoaded;
    const userHasAltOrgs = useMemo(() => {
        if (!config || !user)
            return false;
        const defaultOrg = companySettings.organization;
        const tokenKeyPrefix = config.auth0.tokenKeyPrefix;
        const userOrgRoles = user[`${tokenKeyPrefix}organization_roles`] || {};
        // if exists some org that is not the default org, then user has alt orgs
        return Object.keys(userOrgRoles).some(org => org !== defaultOrg);
    }, [companySettings, config, user]);
    const currentApp = useGetCurrentApp();
    useEffect(() => {
        if (shouldLoadSettings) {
            getCompaniesSettings(isForge, currentApp)
                .then(companiesSettings => {
                setSettings(() => Array.isArray(companiesSettings)
                    ? companiesSettings
                    : [companiesSettings.companySettings]);
                if (!Array.isArray(companiesSettings)) {
                    dispatch(updateWhatsNewState({
                        lastWhatsNewVersionSeen: companiesSettings.lastWhatsNewVersionSeen,
                        isLoading: false,
                    }));
                }
                setError(undefined);
            })
                .catch(e => setError(e))
                .finally(() => setLoaded(true));
        }
    }, [shouldLoadSettings, currentApp]);
    const altSettings = useMemo(() => {
        if (!userHasAltOrgs)
            return [];
        const defaultOrg = companySettings.organization;
        return settings.filter((org) => org.organization !== defaultOrg);
    }, [settings]);
    return { settings, altSettings, loaded, error };
}
